/**
 * SnapshotProgressHeader Component
 * Header showing "Step X of Y" style progress
 */

import { cn } from '@/lib/utils';

interface SnapshotProgressHeaderProps {
  currentStep: number;
  totalSteps: number;
  title?: string;
  className?: string;
}

export function SnapshotProgressHeader({
  currentStep,
  totalSteps,
  title = 'Five-Swing Snapshot',
  className
}: SnapshotProgressHeaderProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <span className="text-sm text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
      </div>
      
      {/* Progress Bar */}
      <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
}


